import {Tooltip} from 'components/tooltip';
import {Utils} from 'common/scripts/utils';

const wrapper = document.querySelector('.j-mask-wrapper');

if (wrapper) {
    const planWrapper = wrapper.querySelector('.j-project-plan');
    const svgWrapper = document.querySelector('.j-project-plan-svg');
    const defaultWidth = svgWrapper.getAttribute('width');
    const defaultHeight = svgWrapper.getAttribute('height');
    const prop = defaultWidth / defaultHeight;
    const masksArray = Array.from(document.querySelectorAll('.j-project-plan-mask'));
    const infraArray = Array.from(document.querySelectorAll('.j-project-plan-infra'));

    // Показываем тултип
    const showTooltip = (elem, type) => {
        const options = {
            target   : elem,
            direction: 'over',
            type
        };

        const tooltip = new Tooltip();

        tooltip.init(options);

        // Прячем тултип при горизонтальным скролле
        wrapper.addEventListener('scroll', (event) => {
            if (event.currentTarget.scrollLeft) {
                tooltip.destroy();
            }
        });
    };

    // Пересчитываем размеры картинки и масок
    const resizeWrapper = () => {
        if (Utils.getWindowWidth() < 670) {
            planWrapper.style.width = `${defaultWidth / 2}px`;
            planWrapper.style.height = `${defaultWidth / 2 / prop}px`;
        } else if (Utils.getWindowWidth() < 1280) {
            planWrapper.style.width = `${defaultWidth / 1.5}px`;
            planWrapper.style.height = `${defaultWidth / 1.5 / prop}px`;
        } else {
            planWrapper.style.width = '100%';
            planWrapper.style.height = '100%';
        }
    };

    // Устанавливаем класс для цвета ховера на элементе маски
    const setHoverClassMask = (item) => {
        if (item.getAttribute('stroke') === 'white') {
            item.classList.add('project-plan__mask-item_hover-color_white');
        }
    };

    masksArray.forEach((item) => {
        setHoverClassMask(item);
        showTooltip(item, 'queue');
    });

    infraArray.forEach((item) => {
        showTooltip(item, 'infra');
    });


    resizeWrapper();

    window.addEventListener('resize', () => {
        resizeWrapper();
    });
}
